import React from 'react';

// Placinta simpla, in SVG pur (fara librarii de grafice) - suficienta pt 2-3
// felii. Fiecare felie: { label, value, color }. Afiseaza si o legenda cu
// valoarea si procentul fiecarei felii sub grafic.
export default function PieChart({ title, slices, size = 150, formatValue }) {
  const total = slices.reduce((s, x) => s + Math.max(0, Number(x.value) || 0), 0);
  const r = size / 2;
  const fmt = formatValue || (v => v);

  let unghiStart = -90; // incepe de sus
  const arcuri = total > 0 ? slices
    .filter(s => Number(s.value) > 0)
    .map(s => {
      const fractie = Number(s.value) / total;
      const unghiCapat = unghiStart + fractie * 360;
      const path = arcSvg(r, r, r, unghiStart, unghiCapat);
      unghiStart = unghiCapat;
      return { ...s, path, procent: (fractie * 100).toFixed(1) };
    }) : [];

  return (
    <div style={{ textAlign: 'center' }}>
      {title && <div style={{ fontSize: 13, fontWeight: 600, color: '#444', marginBottom: 8 }}>{title}</div>}
      {total === 0 ? (
        <p style={{ color: '#888', fontSize: 13 }}>Fara date</p>
      ) : (
        <>
          <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
            {arcuri.map((a, i) => (
              <path key={i} d={a.path} fill={a.color} stroke="#fff" strokeWidth="1" />
            ))}
          </svg>
          <div style={{ marginTop: 8, fontSize: 12, textAlign: 'left', display: 'inline-block' }}>
            {arcuri.map((a, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 3 }}>
                <span style={{ width: 10, height: 10, borderRadius: 2, background: a.color, display: 'inline-block', flexShrink: 0 }} />
                <span>{a.label}: {fmt(a.value)} ({a.procent}%)</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

function polarToCartesian(cx, cy, r, unghiGrade) {
  const rad = (unghiGrade - 0) * Math.PI / 180;
  return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
}

function arcSvg(cx, cy, r, unghiStart, unghiCapat) {
  // Cerc complet (o singura felie = 100%) - arcul SVG normal nu poate desena
  // exact 360 grade, deci il tratam separat ca cerc plin.
  if (unghiCapat - unghiStart >= 359.99) {
    return `M ${cx - r} ${cy} A ${r} ${r} 0 1 1 ${cx + r} ${cy} A ${r} ${r} 0 1 1 ${cx - r} ${cy} Z`;
  }
  const start = polarToCartesian(cx, cy, r, unghiStart);
  const end = polarToCartesian(cx, cy, r, unghiCapat);
  const marePariu = unghiCapat - unghiStart > 180 ? 1 : 0;
  return `M ${cx} ${cy} L ${start.x} ${start.y} A ${r} ${r} 0 ${marePariu} 1 ${end.x} ${end.y} Z`;
}
